import React from 'react'
import { Typography, Avatar, 
  } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types'

const useStylesMessage= makeStyles(theme=>({
    avatar: {
        width:65,
        height:65
    },
    root:{
        display: 'flex',   
        alignItems: 'center',
        padding: '4px 0px'
    },
    data:{
        paddingLeft: 8
    }
}))
const Message =(props)=>{
    const classesMsg = useStylesMessage()
    const {imageSrc, title, msg} = props
    return(
        <div className={classesMsg.root}>
             <Avatar 
                alt= "image"
                src= {imageSrc}
                className={classesMsg.avatar}
                />
            <div className={classesMsg.data}>
            <Typography variant="h6">{title}</Typography>
            <Typography variant="body1">{msg}</Typography>
            </div>
        </div>
    )
}
export default Message
Message.propTypes = {
    title: PropTypes.string.isRequired,
    msg: PropTypes.string.isRequired,
    imageSrc: PropTypes.string.isRequired,
  };